import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhBannerComponent } from './ph-banner.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { HttpLoaderFactory } from 'src/app/app.functions';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [PhBannerComponent],
  exports: [PhBannerComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: true,
    }),
  ],
})
export class PhBannerModule {}
